import Dashboard from "@/views/private/Dashboard.vue"
import ProductClass from "@/views/private/class/Index.vue"
import ProductClassGeneral from "@/views/private/class/General.vue"
import ProductClassDetail from "@/views/private/class/Detail.vue"
import ProductClassStudent from "@/views/private/class/Siswa.vue"
import ProductLibrary from "@/views/private/library/Index.vue"
import ProductLibraryGeneral from "@/views/private/library/General.vue"
import ProductLibraryDetail from "@/views/private/library/Detail.vue"
import ConfigAkunBankDestination from "@/views/private/config/bank/Index.vue"
import ConfigAkunBankRecipient from "@/views/private/config/bank/BankRecipient.vue"
import ConfigPrivacy from "@/views/private/config/privacy/Index.vue"
import ConfigHelp from "@/views/private/config/help/Index.vue"
import ConfigAboutUs from "@/views/private/config/aboutus/Index.vue"
import ConfigSosmed from "@/views/private/config/sosmed/Index.vue"
import ConfigPartner from "@/views/private/config/partner/Index.vue"
import ConfigCategory from "@/views/private/config/category/Index.vue"
import ConfigMentor from "@/views/private/config/mentor/Index.vue"
import ConfigQuestion from "@/views/private/config/question/Index.vue"
import ConfigContent from "@/views/private/config/content/Index.vue"
import TransactionPurchasing from "@/views/private/transaction/purchasing/Index.vue"
import TransactionSelling from "@/views/private/transaction/selling/Index.vue"
import TransactionSellingDetail from "@/views/private/transaction/selling/Detail.vue"
import Member from "@/views/private/member/Index.vue"
import AccessMenu from "@/views/private/access/menu/Index.vue"
import AccessSubMenu from "@/views/private/access/subMenu/Index.vue"
import Admin from "@/views/private/admin/Index.vue"
import AdminGeneral from "@/views/private/admin/General.vue"
import ProfileUser from "@/views/private/profil/Index.vue"
import Notification from "@/views/private/Notification.vue"
import Telegram from "@/views/private/telegram/Index.vue"
import LandingPage from "@/views/private/landing/Index.vue"


const routes = [
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
    meta: {
      title: "Dashboard"
    }
  },
  {
    path: "/class",
    name: "product class",
    component: ProductClass,
    meta: {
      title: "Kelas"
    }
  },
  {
    path: "/class/general",
    name: "product class general",
    component: ProductClassGeneral,
    meta: {
      title: "Buat Kelas"
    }
  },
  {
    path: "/class/siswa/:id",
    name: "product class siswa",
    component: ProductClassStudent,
    meta: {
      title: "Tambah Siswa"
    }
  },
  {
    path: "/class/:id",
    name: "product class detail",
    component: ProductClassDetail,
    meta: {
      title: "Detail Kelas"
    }
  },
  {
    path: "/library",
    name: "product library",
    component: ProductLibrary,
    meta: {
      title: "Materi"
    }
  },
  {
    path: "/library/general",
    name: "product library general",
    component: ProductLibraryGeneral,
    meta: {
      title: "Buat Materi"
    }
  },
  {
    path: "/library/:id",
    name: "product library detail",
    component: ProductLibraryDetail,
    meta: {
      title: "Detail Materi"
    }
  },
  {
    path: "/config/bank/destination",
    name: "config bank destination",
    component: ConfigAkunBankDestination,
    meta: {
      title: "Bank Penerima"
    }
  },
  {
    path: "/config/bank/recipient",
    name: "config bank recipient",
    component: ConfigAkunBankRecipient,
    meta: {
      title: "Bank Pengirim"
    }
  },
  {
    path: "/config/privacy",
    name: "config privacy",
    component: ConfigPrivacy,
    meta: {
      title: "Kebijakan Privasi"
    }
  },
  {
    path: "/config/help",
    name: "config help",
    component: ConfigHelp,
    meta: {
      title: "Bantuan"
    }
  },
  {
    path: "/config/aboutus",
    name: "config aboutus",
    component: ConfigAboutUs,
    meta: {
      title: "Tentang Kami"
    }
  },
  {
    path: "/config/sosmed",
    name: "config sosmed",
    component: ConfigSosmed,
    meta: {
      title: "Sosial Media"
    }
  },
  {
    path: "/config/partner",
    name: "config partner",
    component: ConfigPartner,
    meta: {
      title: "Mitra"
    }
  },
  {
    path: "/config/category",
    name: "config category",
    component: ConfigCategory,
    meta: {
      title: "Kategori"
    }
  },
  {
    path: "/config/mentor",
    name: "config mentor",
    component: ConfigMentor,
    meta: {
      title: "Mentor"
    }
  },
  {
    path: "/config/question",
    name: "config question",
    component: ConfigQuestion,
    meta: {
      title: "Pertanyaan"
    }
  },
  {
    path: "/config/content",
    name: "config content",
    component: ConfigContent,
    meta: {
      title: "Konten"
    }
  },
  {
    path: "/transaction/purchasing",
    name: "transaction purchasing",
    component: TransactionPurchasing,
    meta: {
      title: "Transaksi"
    }
  },
  {
    path: "/transaction/selling",
    name: "transaction selling",
    component: TransactionSelling,
    meta: {
      title: "Penjualan"
    }
  }, 
  {
    path: "/transaction/selling/:id",
    name: "transaction selling detail",
    component: TransactionSellingDetail,
    meta: {
      title: "Detail Penjualan" 
    }
  }, 
  {
    path: "/member",
    name: "member",
    component: Member,
    meta: {
      title: "Pengguna"
    }
  }, 
  {
    path: "/access/menu",
    name: "access menu",
    component: AccessMenu,
    meta: {
      title: "Hak Akses Menu"
    }
  }, 
  {
    path: "/access/sub-menu",
    name: "access submenu",
    component: AccessSubMenu,
    meta: {
      title: "Hak Akses Sub Menu"
    }
  },
  {
    path: "/admin",
    name: "admin",
    component: Admin,
    meta: {
      title: "Admin"
    }
  },
  {
    path: "/admin/general",
    name: "admin",
    component: AdminGeneral,
    meta: {
      title: "Buat Admin"
    }
  },
  {
    path: "/profil",
    name: "profil",
    component: ProfileUser,
    meta: {
      title: "Profil Pengguna"
    }
  },
  {
    path: "/notification",
    name: "notification",
    component: Notification,
    meta: {
      title: "Pemberitahuan"
    }
  },
  {
    path: "/telegram",
    name: "telegram",
    component: Telegram,
    meta: {
      title: "Telegram"
    }
  },
  {
    path: "/landing",
    name: "landing",
    component: LandingPage,
    meta: {
      title: "Landing Page"
    }
  }
]

export default routes.map(route => {
  const meta = {
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})